<script setup>
import { onMounted } from "vue";
onMounted(() => {
  require("@/assets/js/ppf.js");
});
</script>
<template>
  <main class="seo-calculators nav-seo npm-seo">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a>
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>Public Provident Fund Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->
    <div class="container">
      <h1 class="page-heading">PPF Calculator</h1>
      <h2 class="page-sub-heading">Calculate your public provident fund.</h2>
      <div class="container no-padding-web">
        <div class="row">
          <div class="col-md-6 no-padding">
            <div class="slider-container">
              <form name="calculator">
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Yearly investment amount</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="totalInvestments"
                        value="10000"
                        min="500"
                        max="150000"
                        step="1"
                        id="total-investment-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="10000"
                    min="500"
                    max="150000"
                    step="1"
                    id="total-investment-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />

                  <div class="slider__row">
                    <div class="slider__min">₹500</div>
                    <div class="slider__max">₹1,50,000</div>
                  </div>
                </div>
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Number of years</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="timePeriod"
                        value="34"
                        step="1"
                        min="15"
                        max="50"
                        data-current-value=""
                        id="period-input"
                      /><span class="m-l-4">yrs</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    value="34"
                    step="1"
                    min="15"
                    max="50"
                    id="period-input-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div class="slider__row">
                    <div class="slider__min">15 yrs</div>
                    <div class="slider__max">50 yrs</div>
                  </div>
                </div>
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Current interest rate</h3>

                    <h3 class="slider__heading">
                      <input type="hidden" id="interest" value="7.1" />7.1%
                    </h3>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="col-md-6 no-padding cstm-ppf-chart" id="fix-cash">
            <aside class="calculator-output nps-sidebar">
              <h3 class="calculator-output__heading">Total invested amount</h3>
              <div
                id="total-investment"
                class="calculator-output__amount--large"
              >
                ₹ 3,40,000
              </div>
              <div class="calculator-output__row">
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">Total interest</h3>
                  <div
                    id="total-interest"
                    class="calculator-output__amount--small"
                  >
                    ₹ 10,62,876
                  </div>
                </div>
                <div class="calculator-output__col">
                  <h3 class="calculator-output__heading">Maturity amount</h3>
                  <div
                    id="total-maturity"
                    class="calculator-output__amount--small"
                  >
                    ₹ 14,02,876
                  </div>
                </div>
              </div>
              <div class="calculator-output__chart-container">
                <canvas
                  id="mfChart"
                  width="200"
                  height="200"
                  style="
                    display: block;
                    box-sizing: border-box;
                    height: 200px;
                    width: 200px;
                  "
                ></canvas>
                <div class="calculator-output__chart-container--legend">
                  <div class="legend-title">
                    <span class="purple"></span>
                    <h3>Total investment amount</h3>
                  </div>
                  <div class="legend-title">
                    <span class="gold"></span>
                    <h3>Total interest</h3>
                  </div>
                </div>
              </div>
              <a href="https://wa.me/+917092362098" class="cta"
                >Invest Now</a
              >
            </aside>
          </div>
        </div>
      </div>
    </div>

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>What is the PPF scheme?</h2>
      <p></p>
      <p>
        The Public Provident Fund (PPF) scheme is a sovereign backed, tax free,
        long-term saving-cum-investment scheme that offers a unique combination
        of safety, stability, returns, tax savings and long-term wealth
        creation. Maximum investment allowed in PPF is up to ₹1.5 lakh per year
        with a minimum amount of ₹500 per year. The lock-in period is 15 years,
        and it can be extended indefinitely in blocks of five years. There is an
        option of partial withdrawal after 5 years, subject to conditions. You
        can take a loan on your PPF account between the 3rd and 5th years. The
        current interest rate on PPF is 7.1%. The interest rate is set by the
        government every quarter. The Exempt-Exempt-Exempt (EEE) scheme, which
        allows investors to avail a tax exemption on the deposited amount, the
        cumulative amount and the interest earned on the PPF account, at the
        time of withdrawal. PPF accounts cannot be held jointly, though you can
        make a nomination.It can be a tool to build a corpus for various life
        goals such as retirement, children’s education, etc.
      </p>
      <p></p>
    </section>

    <!-- Calculator Faqs Section-->

    <section class="container calculator_help_section">
      <h2 class="fs-28 bold help_here">Frequently Asked Questions</h2>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse1">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How does the PPF calculator work?</span>
                </span>
              </h3>
            </div>
            <div id="collapse1" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  An investor can use PPF calculator to find out his/her amount
                  on maturity based on tenure, interest rate, frequency of
                  investment and the investment amount. The online calculator
                  generates the output instantly, free of charge for any number
                  of iterations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse2">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Formula for calculating the interest on PPF:</span>
                </span>
              </h3>
            </div>
            <div id="collapse2" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>F = P[{(1+i)^n-1}/i]</p>
                <p>where,</p>
                <ul style="list-style: disc; padding-left: 45px">
                  <li>‘F’ stands for the maturity amount of the PPF</li>
                  <li>‘P’ stands for the annual instalments paid</li>
                  <li>
                    ‘n’ stands for the number of years or tenure of the PPF
                  </li>
                  <li>‘i’ stands for the rate of interest.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse3">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >It should be noted that the interest on PPF is compounded
                    on a yearly basis</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse3" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  The investor has to just enter the investment amount and
                  tenure of the PPF and the calculator would generate the amount
                  on maturity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse4">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Who is eligible for a PPF account? </span>
                </span>
              </h3>
            </div>
            <div id="collapse4" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>Any Indian citizen can open a PPF account.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse5">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How can I make deposits in my PPF account?</span>
                </span>
              </h3>
            </div>
            <div id="collapse5" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  You can make deposits every month or in a lump sum through
                  cash, cheque, DD or online transfer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse6">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Can I make my deposits in PPF online?</span>
                </span>
              </h3>
            </div>
            <div id="collapse6" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>Yes, you can invest in a PPF account online.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse7">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Can I open more than one PPF account?</span>
                </span>
              </h3>
            </div>
            <div id="collapse7" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  No. There can be only one PPF account per individual. However,
                  you can open a PPF account in your minor child’s name.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse8">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Where can I open a PPF account?</span>
                </span>
              </h3>
            </div>
            <div id="collapse8" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  All the nationalised banks offer the facility to open PPF
                  accounts. Besides, a number of private banks are also entitled
                  to offer the PPF account facility.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse9">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How can I open a PPF account?</span>
                </span>
              </h3>
            </div>
            <div id="collapse9" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  In order to open a PPF account, an applicant will be required
                  to submit KYC documents in addition to a duly filled and
                  signed application form. For KYC, the applicant will be
                  required to submit a proof of identity, address, and
                  signature. After submitting these documents and the form, the
                  amount towards the opening of the PPF account can be
                  deposited.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse10">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >What happens if I miss my contribution for a year?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse10" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  If you miss making your contribution for a year, the account
                  will become dormant.<br />
                  You can make it active by paying a minimum contribution of
                  ₹500 and penalty of ₹50 for each year you missed making a
                  contribution.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse11">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How is the PPF maturity period calculated?</span>
                </span>
              </h3>
            </div>
            <div id="collapse11" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  The maturity period is 15 years from the end of the financial
                  year when the first investment is done. For instance, if you
                  made the first investment in December 2021, then your first
                  full year of investment would be April 2022 to March 2023 and
                  your account would mature in March 2037.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse12">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is the interest rate for PPF?</span>
                </span>
              </h3>
            </div>
            <div id="collapse12" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  The Ministry of Finance is responsible for setting the
                  interest rate for PPF. This rate is set every year. Currently,
                  the PPF interest rate has been reduced from 7.9% to 7.1%.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse13">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >Which amount is taken into consideration for calculating
                    the interest?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapse13" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  The interest on PPF is calculated on the lowest balance in the
                  account between the closing balance on the 5th day of a month
                  and the closing balance on the last day of the month.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button class="similar-btn btn-all">View all</button>
          <button class="similar-btn btn-less" style="display: none">
            View less
          </button>
        </div>
        <div class="smooth-wrap">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Brokerage Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Margin Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Mutual Fund Returns Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SIP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPV Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Future Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> SWP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> ELSS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Option Value Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> NPS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Annual Growth Rate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> National Savings Certificate Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Sukanya Samriddhi Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Compound Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Atal Pension Yojana Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Gratuity calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Simple Interest Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> Fixed Deposit Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> GST Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a> HRA Calculator</a>
            </h3>
          </div>
        </div>
      </div>
    </section>

    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style scoped>
</style>
